import React, { Component } from 'react';
import { Icon, Breadcrumb, Table, Button, Segment, Step, Message, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { post } from '../../../util/api';
import { withTranslation } from 'react-i18next';
import Page from '../../../components/Page';
import MyMenu from '../menu';
import AccountProgress from '../../../components/AccountProgress';

const WHATSAPP_APP_ID = process.env.REACT_APP_WHATSAPP_APP_ID || '296064065127789';
const WHATSAPP_APP_REDIRECT_URL = process.env.REACT_APP_WHATSAPP_APP_REDIRECT_URL || 'https://app.dialogtab.com/settings/integrations/dialogtabwaba';
const scope = ['whatsapp_business_management', 'whatsapp_business_messaging', 'business_management'].join(',');
const redirect_url = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${WHATSAPP_APP_ID}&redirect_uri=${WHATSAPP_APP_REDIRECT_URL}&response_type=token&scope=${scope}`;

class WhatsAppNumberSelector extends Component {
	state = { loading: true, buttonLoading: -1, list: [], error: false, status: null, accounts: [], connectedNumbers: null, error_message: null };

	componentDidMount() {
		this.fetchWhatsAppNumbers();
		this.setState({ connectedWabas: this.props.connectedWabas });
	}
	getList = async () => {
		await post('/messenger/waba/register/list', {}).then((data) => {
			let filtered = _.filter(data.data.result, function (it) {
				return it.accessToken;
			});

			if (filtered && filtered.length > 0) {
				this.setState({ connectedWabas: filtered, activeStep: 1 });
			} else {
				this.setState({ connectedWabas: null, activeStep: 0 });
			}
		});

		// if (apiresponse) this.setState({ connectedPages, loading: false, list: apiresponse.data });
		// else this.setState({ connectedPages, loading: false, error: 'etc...' });
	};

	fetchWhatsAppNumbers = async () => {
		const { accessToken } = this.props;
		try {
			// Fetch business accounts
			const businessResponse = await fetch(`https://graph.facebook.com/v20.0/me/businesses?access_token=${accessToken}&fields=id,name,link`);
			const businessData = await businessResponse.json();

			if (businessData.error) {
				throw new Error(businessData.error.message);
			}

			const connectedNumbers = [];

			// Fetch WhatsApp accounts for each business
			for (const business of businessData.data) {
				const wabaResponse = await fetch(
					`https://graph.facebook.com/v20.0/${business.id}/owned_whatsapp_business_accounts?access_token=${accessToken}`
				);
				const wabaData = await wabaResponse.json();

				if (wabaData.error) {
					console.error(`Error fetching WABA for business ${business.id}:`, wabaData.error.message);
					continue;
				}

				for (const waba of wabaData.data) {
					connectedNumbers.push({
						id: waba.id,
						wabaId: waba.id,
						display_phone_number: waba.name, // Note: The actual phone number might not be available in this response
						businessName: business.name,
						accessToken: accessToken,
					});
				}
			}

			this.setState({ connectedNumbers, loading: false });
		} catch (error) {
			this.setState({ error: true, error_message: error.message, loading: false });
		}
	};

	connect = (number) => async () => {
		this.setState({ buttonLoading: number.id });
		try {
			await post('/messenger/waba/register/connect', {
				phone_number_id: number.id,
				waba_id: number.wabaId,
				access_token: this.props.accessToken,
			});
			this.getList();
			this.fetchWhatsAppNumbers();
		} catch (error) {
			this.setState({ error: true, error_message: error.message });
		}
		this.setState({ buttonLoading: -1 });
	};

	disconnect = (number) => async () => {
		this.setState({ buttonLoading: number.id });
		try {
			await post('/messenger/waba/register/disconnect', { shop: number.display_phone_number, phone_number_id: number.phone_number_id });
			this.getList();
			this.fetchWhatsAppNumbers();
		} catch (error) {
			this.setState({ error: true, error_message: error.message });
		}
		this.setState({ buttonLoading: -1 });
	};

	render() {
		const { t } = this.props;
		const { loading, connectedNumbers, error_message, connectedWabas } = this.state;

		if (loading)
			return (
				<div style={{ textAlign: 'center' }}>
					<Icon name="asterisk" loading />
					<p>{t('loading')}</p>
				</div>
			);
		console.log('connectedNumbers', connectedNumbers);
		return (
			<div>
				<div style={{ textAlign: 'center', marginTop: '20px', display: 'flex' }}>
					<Button color="green" style={{ marginLeft: 'auto' }} as="a" href={redirect_url}>
						{t('loginWithWhatsAppBusiness')}
					</Button>
				</div>
				{error_message && (
					<Message error style={{ textAlign: 'center' }}>
						{error_message}
					</Message>
				)}
				{(connectedNumbers && connectedNumbers.length) || (connectedWabas && connectedWabas.length > 0) ? (
					<Table>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>{t('name')}</Table.HeaderCell>
								<Table.HeaderCell>WhatsApp Business</Table.HeaderCell>
								<Table.HeaderCell></Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{console.log('connectedNumbers', connectedWabas)}
							{connectedNumbers &&
								connectedNumbers.length &&
								connectedNumbers.map((number) => {
									let isConnected = _.find(connectedWabas, (it) => it.data && it.data.phone_number_id === number.wabaId);
									console.log('isConnected', isConnected);
									return (
										<Table.Row key={number.id}>
											<Table.Cell>{number.businessName}</Table.Cell>
											<Table.Cell>
												{number.display_phone_number + (isConnected && isConnected.shop ? ' - ' + isConnected.shop : '')}
											</Table.Cell>
											<Table.Cell style={{ textAlign: 'end' }}>
												{isConnected ? (
													<Link to={`/settings/integrations/dialogtabtemplates?number=${isConnected.shop}`}>
														<Button color={'teal'} loading={this.state.buttonLoading === number.id}>
															Template
														</Button>
													</Link>
												) : (
													''
												)}
												<Button
													color={isConnected ? 'red' : 'green'}
													loading={this.state.buttonLoading === number.id}
													onClick={isConnected ? this.disconnect(isConnected.data) : this.connect(number)}
												>
													{isConnected ? t('disconnect') : t('connect')}
												</Button>
											</Table.Cell>
										</Table.Row>
									);
								})}

							{!(connectedNumbers && connectedNumbers.length) && connectedWabas && connectedWabas.length
								? connectedWabas.map((number) => {
										let isConnected = true;
										console.log('phone_number_id', number);
										return (
											<Table.Row key={number.id}>
												<Table.Cell>{number.data.waba_id}</Table.Cell>
												<Table.Cell>{number.data.display_phone_number}</Table.Cell>
												<Table.Cell style={{ textAlign: 'end' }}>
													<Link to={`/settings/integrations/dialogtabtemplates?number=${number.shop}`}>
														<Button color={'teal'} loading={this.state.buttonLoading === number.id}>
															Template
														</Button>
													</Link>
													<Button
														color={isConnected ? 'red' : 'green'}
														loading={this.state.buttonLoading === number.id}
														onClick={isConnected ? this.disconnect(number.data) : this.connect(number)}
													>
														{isConnected ? t('disconnect') : t('connect')}
													</Button>
												</Table.Cell>
											</Table.Row>
										);
								  })
								: null}
						</Table.Body>
					</Table>
				) : (
					<Message warning style={{ textAlign: 'center' }}>
						{t('noWhatsAppNumbersFound')}
					</Message>
				)}
			</div>
		);
	}
}

class WhatsAppIntegration extends Component {
	state = {
		loading: true,
		activeStep: 0,
		connectedCount: 0,
		error_description: null,
		accessToken: null,
	};

	async componentDidMount() {
		await this.getList();
		await this.lookAtQueries();
	}
	getList = async () => {
		await post('/messenger/waba/register/list', {}).then((data) => {
			let filtered = _.filter(data.data.result, function (it) {
				return it.accessToken;
			});

			if (filtered && filtered.length > 0) {
				this.setState({ connectedWabas: filtered, activeStep: 1 });
			} else {
				this.setState({ connectedWabas: null, activeStep: 0 });
			}
		});

		// if (apiresponse) this.setState({ connectedPages, loading: false, list: apiresponse.data });
		// else this.setState({ connectedPages, loading: false, error: 'etc...' });
	};
	getWhatsAppStatus = async () => {
		try {
			const response = await post('/messenger/waba/integrationCount');
			const connectedCount = response.data.result || 0;
			this.setState({ connectedCount, loading: false });
		} catch (error) {
			this.setState({ error_description: error.message, loading: false });
		}
	};

	lookAtQueries = async () => {
		const { location } = this.props;
		const { hash } = location;

		// Remove the leading '#' and parse the fragment
		const params = new URLSearchParams(hash.substring(1));

		console.log('location', location);

		const access_token = params.get('access_token');
		const data_access_expiration_time = params.get('data_access_expiration_time');
		const expires_in = params.get('expires_in');
		const long_lived_token = params.get('long_lived_token');

		console.log('access_token', access_token);

		if (access_token) {
			this.setState({ loading: true });
			try {
				const result_data = {
					access_token,
					data_access_expiration_time,
					expires_in,
					long_lived_token,
				};

				this.setState({
					status: 'success',
					loading: false,
					result_data,
					activeStep: 1,
					accessToken: long_lived_token || access_token,
				});
			} catch (error) {
				this.setState({
					status: 'denied',
					error_description: error.message,
					loading: false,
				});
			}
		} else if (params.get('error')) {
			this.setState({
				status: 'denied',
				error_description: params.get('error_description'),
				loading: false,
			});
		} else {
			this.setState({ loading: false });
		}
	};

	render() {
		const { t } = this.props;
		const { loading, activeStep, connectedCount, error_description, accessToken, connectedWabas } = this.state;

		if (loading) return <Page.Loader />;
		console.log('activeStep', accessToken, activeStep);
		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/settings`}>
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
							{t('integrations')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section>WhatsApp Business</Breadcrumb.Section>
					</Breadcrumb>
				}
				extra={
					<div className="ml-auto">
						<AccountProgress />
					</div>
				}
				flex
			>
				<MyMenu activeItem="whatsapp">
					<Page.Wrap>
						<Segment>
							{connectedCount > 0 && (
								<Message info style={{ textAlign: 'center' }}>
									{t('whatsappConnectedCount', { count: connectedCount })}
								</Message>
							)}
							<Message info style={{ textAlign: 'center' }}>
								{t('whatsappIntegrationDesc', { title: window.CONFIG.title })}
							</Message>
							<Step.Group widths={2}>
								<Step active={activeStep === 0} completed={activeStep === 1}>
									<Icon name="whatsapp" />
									<Step.Content>
										<Step.Title>{t('loginWhatsAppBusiness')}</Step.Title>
									</Step.Content>
								</Step>
								<Step active={activeStep === 1}>
									<Icon name="linkify" />
									<Step.Content>
										<Step.Title>{t('connectWhatsAppNumber')}</Step.Title>
									</Step.Content>
								</Step>
							</Step.Group>
							{error_description && (
								<Message error style={{ textAlign: 'center' }}>
									{error_description}
								</Message>
							)}
							{activeStep === 0 ? (
								<div style={{ textAlign: 'center', marginTop: '20px' }}>
									<Button color="green" as="a" href={redirect_url}>
										{t('loginWithWhatsAppBusiness')}
									</Button>
								</div>
							) : (
								<WhatsAppNumberSelector t={t} accessToken={accessToken} connectedWabas={connectedWabas} />
							)}
						</Segment>
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	product: state.product,
	location: state.router.location,
});

export default connect(stateToProps)(withTranslation()(WhatsAppIntegration));
